import { FormLabel, Grid, Typography } from "@material-ui/core";
import React from "react";
import { injectIntl, WithIntlProps } from "react-intl";
import { InternalTaskViewModel } from "../../../model/InternalTaskViewModel";
import TranslatedMessage from "../../translations/TranslatedMessage";
import { TranslationKey } from "../../../translations/TranslationKey";

type CandidateFieldsProps = { task: InternalTaskViewModel } & WithIntlProps<any>;

type RowProps = { title: TranslationKey; children: any };

const CandidateFields: React.FC<CandidateFieldsProps> = ({ task, intl }) => {
  const Row = ({ title, children }: RowProps) => {
    return (
      <Grid item container direction="row" alignItems="baseline">
        <Grid item xs={12} sm={6} md={4}>
          <FormLabel>
            <TranslatedMessage id={title} />
          </FormLabel>
        </Grid>
        <Grid item xs={12} sm={6} md={8}>
          <Typography>{children}</Typography>
        </Grid>
      </Grid>
    );
  };
  return (
    <Grid item container direction="column" xs={12} md={6}>
      <Typography style={{ fontWeight: "bold" }}>
        <TranslatedMessage id="cancellationTaskForm.candidateSubHeader" />
      </Typography>

      <Row title="cancellationTaskForm.emailLabel">{task.candidateEmailAddress}</Row>
      <Row title="cancellationTaskForm.firstNameLabel">{task.candidateFirstName}</Row>
      <Row title="cancellationTaskForm.lastNameLabel">{task.candidateLastName}</Row>
      <Row title="common.orderId">{task.orderId > 0 ? task.orderId : ""}</Row>
      <Row title="common.debtorNumber">{task.abacusDebtorNumber}</Row>
      <Row title="common.transaction.id">{task.transactionId}</Row>
    </Grid>
  );
};

export default injectIntl(CandidateFields);
